import React from "react";
import * as S from "./SideBySideSectionCard.style";

const SideBySideSectionCard = ({
  title,
  title2,
  align,
  subtext1,
  subtext2,
  subtext3,
  subtext4,
  subtext5,
  subtext6,
  id,
}) => {
  return (
    <S.Container
      style={{
        display: "flex",
        justifyContent: "space-around",
        textWrap: "pretty",
      }}
      id={id}
      align={align}
    >
      <S.SectionTitle>
        <S.Title>{title}</S.Title>
        <S.Title>
          <>
            {subtext1 && (
              <S.TextStyled variant="body02-sm">{subtext1}</S.TextStyled>
            )}
            {subtext2 && (
              <S.TextStyled variant="body02-sm">{subtext2}</S.TextStyled>
            )}
            {subtext3 && (
              <S.TextStyled variant="body02-sm">{subtext3}</S.TextStyled>
            )}
          </>
        </S.Title>
      </S.SectionTitle>
      <S.SectionText>
        <S.Title>{title2}</S.Title>
        <S.Title>
          <>
            {subtext4 && (
              <S.TextStyled variant="body02-sm">{subtext4}</S.TextStyled>
            )}
            {subtext5 && (
              <S.TextStyled variant="body02-sm">{subtext5}</S.TextStyled>
            )}
            {subtext6 && (
              <S.TextStyled variant="body02-sm">{subtext6}</S.TextStyled>
            )}
          </>
        </S.Title>
      </S.SectionText>
    </S.Container>
  );
};

export default SideBySideSectionCard;
